var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "fill-height": "" } },
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "" } },
        [
          _c(
            "v-flex",
            [
              _c("h3", { staticClass: "display-3" }, [
                _vm._v("Great, let's get started. ")
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "display-1" }, [
                _vm._v("Blogs and labels typically respond within hours.")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "subheading" }, [
                _vm._v(
                  "If a blog decides that they like your piece, they'll let you know when and how they plan to share it. You'll be able to chat with them, and share any information you think they might need for their coverage."
                )
              ]),
              _vm._v(" "),
              _c("v-divider", { staticClass: "my-3" }),
              _vm._v(" "),
              _c("div", { staticClass: "title mb-3" }, [
                _vm._v("Let's Upload your art piece!")
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mx-0",
                  attrs: {
                    color: "primary",
                    depressed: "",
                    large: "",
                    router: "",
                    to: "/upload_an_image1"
                  },
                  on: { click: _vm.onPickFile }
                },
                [_vm._v("\n        Upload your art\n      ")]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: "image/*" },
                on: { change: _vm.onFilePicked }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mx-0",
                  attrs: {
                    depressed: "",
                    large: "",
                    color: "primary",
                    router: "",
                    to: "/upload_an_image",
                    disabled: _vm.image_is_not_loaded
                  },
                  on: { click: _vm.getUserId }
                },
                [_vm._v("Next\n\n      ")]
              ),
              _vm._v(" "),
              _c("v-layout", [
                _c(
                  "div",
                  { staticClass: "text-xs-center", attrs: { id: "tour" } },
                  [
                    _c("v-tour", {
                      attrs: {
                        name: "myTour",
                        steps: _vm.steps,
                        callbacks: _vm.myCallbacks
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(tour) {
                            return [
                              _c(
                                "transition",
                                { attrs: { name: "fade" } },
                                _vm._l(tour.steps, function(step, index) {
                                  return tour.currentStep === index
                                    ? _c(
                                        "v-step",
                                        {
                                          key: index,
                                          attrs: {
                                            step: step,
                                            "previous-step": tour.previousStep,
                                            "next-step": tour.nextStep,
                                            stop: tour.stop,
                                            "is-first": tour.isFirst,
                                            "is-last": tour.isLast,
                                            labels: tour.labels
                                          }
                                        },
                                        [
                                          tour.currentStep === 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "actions" },
                                                    slot: "actions"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                          large: "",
                                                          depressed: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: tour.nextStep
                                                        }
                                                      },
                                                      [_vm._v("Yes")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                          large: "",
                                                          depressed: "",
                                                          color: "primary"
                                                        },
                                                        on: { click: tour.stop }
                                                      },
                                                      [_vm._v("No")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          tour.currentStep === 1
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "actions" },
                                                    slot: "actions"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                          depressed: "",
                                                          color: "primary"
                                                        },
                                                        on: { click: tour.stop }
                                                      },
                                                      [_vm._v("Close")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                          depressed: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: tour.nextStep
                                                        }
                                                      },
                                                      [_vm._v("Next Step")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          tour.currentStep === 2
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "actions" },
                                                    slot: "actions"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                          depressed: "",
                                                          color: "primary"
                                                        },
                                                        on: { click: tour.stop }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    Close\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                })
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9503fe06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9503fe06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/upload_an_image1.vue
// module id = null
// module chunks = 